import { Button, Flex, Group, Switch } from "@mantine/core";
import { UseFormReturnType } from "@mantine/form";
import { EventFormValues } from "./types";

interface EventFormActionsProps {
  form: UseFormReturnType<EventFormValues>;
  t: (key: string) => string;
  isNew: boolean;
  isPending: boolean;
  currOrganizerId?: number;
  navigate: (to: number) => void;
  setShowPushModal: (show: boolean) => void;
  isApplication?: boolean;
  /** Desk mode: replaces the common.create / common.save submit text. */
  submitLabel?: string;
  /** Desk mode: replaces the common.cancel text. */
  backLabel?: string;
  /** Desk mode: replaces navigate(-1) on the back button. */
  onBack?: () => void;
  /** Desk apply mode: hides the "Send push" button (D-15). */
  hidePushButton?: boolean;
}

export const EventFormActions = ({
  form,
  t,
  isNew,
  isPending,
  currOrganizerId,
  navigate,
  setShowPushModal,
  isApplication = false,
  submitLabel,
  backLabel,
  onBack,
  hidePushButton = false,
}: EventFormActionsProps) => {
  return (
    <Flex
      mb={10}
      px={10}
      direction="row"
      justify="space-between"
      align="center"
      style={{ boxShadow: "4px 2px 6px rgba(0, 0, 0, 0.3)" }}
    >
      <Group py={10}>
        <Button type="submit" loading={isPending}>
          {submitLabel ??
            (isApplication || isNew ? t("common.create") : t("common.save"))}
        </Button>
        <Button
          variant="light"
          onClick={() => (onBack ? onBack() : navigate(-1))}
        >
          {backLabel ?? t("common.cancel")}
        </Button>
        <Switch
          ml="xl"
          size="xl"
          onLabel={t("events.published")}
          offLabel={t("events.draft")}
          color="green"
          {...form.getInputProps("published")}
          checked={form.values.published || false}
          onChange={(event) => {
            form.setFieldValue("published", event.currentTarget.checked);
            // Validate immediately when switching to published
            if (event.currentTarget.checked) {
              form.validate();
            }
          }}
        />
        {!isNew && !isApplication && (
          <Switch
            ml="xl"
            size="xl"
            onLabel={t("events.cancelled")}
            offLabel={t("events.cancelled")}
            color="red"
            {...form.getInputProps("cancelled")}
            checked={form.values.cancelled || false}
          />
        )}
      </Group>
      {!currOrganizerId && !isApplication && !hidePushButton && (
        <Group>
          <Button
            onClick={() => {
              setShowPushModal(true);
            }}
          >
            {t("events.send_push")}
          </Button>
        </Group>
      )}
    </Flex>
  );
};
